import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Packages from './pages/Packages';
import Contact from './pages/Contact';
import Teachers from './pages/Teachers';
import Colaborari from './pages/Colaborari';
import TermsAndConditions from './pages/TermsAndConditions';
import Seo from './components/Seo';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Seo />
        <Navbar />
        <main id="main-content" className="flex-grow" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/teachers" element={<Teachers />} />
            <Route path="/colaborari" element={<Colaborari />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
